import lodash from 'lodash';

// 节流函数
export const throttle = () => {
    let startTime = null;
    return (time, callback) =>
        new Promise((resolve, reject) => {
            const nowTime = new Date().getTime();
            if (!startTime || nowTime - startTime > time) {
                startTime = nowTime;
                callback && callback instanceof Function && callback();
                resolve();
                // callback&&callback()
            } else {
                reject();
            }
        });
};

// 防抖函数
export const stabilization = () => {
    let timer = null;
    return (time, callback) => {
        return new Promise((resolve, reject) => {
            window.clearTimeout(timer);
            timer = setTimeout(() => {
                callback && callback instanceof Function && callback();
                resolve();
            }, time);
        });
    };
};

// 因为状态拦截需要传递的是地址，所以只能传对象参数
export const statusThrottle = (() => {
    const objParameter = {
        status: true,
    };
    return (callback) => {
        return new Promise((resolve, reject) => {
            if (!lodash.isObject(objParameter)) {
                reject();
                return;
            }

            if (objParameter.status === false) {
                reject();
                return;
            }
            objParameter.status = false;
            callback && callback instanceof Function && callback(objParameter);
            resolve(objParameter);
        });
        // callback && callback(objParameter)
    };
})();
